import { PeriscopeState } from '@sonar-software/sonar-ts-types';

export const defaultPeriscopeState: PeriscopeState = {
	analysisTarget: null,
	cards: []
};
